import { Component, signal } from '@angular/core';
import { NeverumeComponent } from "./../neverume.component";
import { WebsocketService } from "./../services/websocket.service";
import { ArrayAssociative } from "./../core/array.core.data";


@Component({
	selector: 'authentication',
	templateUrl: './authentication.component.html',
	styleUrls: ['./authentication.component.scss'],
	providers: [NeverumeComponent],
	standalone: !true

})
export class AuthenticationComponent {
	selfsuperscription: string = '';
	password: string = '';
	hide = signal(true);

	constructor(private websocketService: WebsocketService) {
	}
	
	lookEvent(event: Event) {
	  this.hide.set(!this.hide());
	  event.stopPropagation();
	}


	facebook() {
		let message: ArrayAssociative = {
			event: 'oauth',
			route: '/auth/social',
			social: 'facebook'
		}
		this.websocketService.sendws(message);
	}


	x() {
		let message: ArrayAssociative = {
			event: 'oauth',
			route: '/auth/social',
			social: 'x'
		}
		
		this.websocketService.sendws(message);
	}

	vk() {
		let message: ArrayAssociative = {
			event: 'oauth',
			route: '/auth/social',
			social: 'vk'
		}
		this.websocketService.sendws(message);
	}

	google() {
		let message: ArrayAssociative = {
			event: 'oauth',
			route: '/auth/social',
			social: 'google'
		}
		this.websocketService.sendws(message);
	}

	onSubmit() {
		let message: ArrayAssociative = {
			event: 'auth',
			route: '/auth',
			selfsuperscription: this.selfsuperscription,
			password: this.password,
		}

		this.websocketService.sendws(message);
	}
}
